<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<div class="boxA" :class="{ sticky: isSticky }">
			<div class="topNav" >
				<span :class="topNavid==item.id?'onsele':''" v-for="(item,index) in radio2Data" @click="topClick(item)">{{item.name}}{{college_arr.length?' / '+college_arr.length:''}}</span>
			</div>
			<div style="display: flex;align-items: center;">
			 <el-dropdown trigger="click" @command="handleCommand" style="margin-right: 10px;">
			    <el-button type="danger"  size="medium" >
			      {{queryParams.sort==2?'拖动选择排序':(queryParams.sort==0?'分数排序':'位次排序')}}<i class="el-icon-arrow-down el-icon--right"></i>
			    </el-button>
			    <el-dropdown-menu slot="dropdown" >
			      <el-dropdown-item command="0">分数排序</el-dropdown-item>
			      <el-dropdown-item command="1">位次排序</el-dropdown-item>
			      <el-dropdown-item command="2">拖动选择排序</el-dropdown-item>
			    </el-dropdown-menu>
			  </el-dropdown>
			  <!-- <el-button type="danger" icon="el-icon-setting" size="medium" @click="zhiClick">智能调整</el-button> -->
			  <el-button type="danger" icon="el-icon-s-claim" size="medium" @click="saveClick">保存方案</el-button>
			  <el-button type="danger" icon="el-icon-delete" size="medium" @click="saveDeleClick">清空方案</el-button>
			  <el-button type="danger" icon="el-icon-download" size="medium" @click="handleExport">导出方案</el-button>
			</div>
		</div>
			<!-- 学校列表 -->
		<div class="schmain">
			<div class="sch-ul" v-show="college_arr&&college_arr.length"  ref="scrollContainer" >
				<!-- @click="goInfo(item)" -->
				<div class="sch-li" v-for="(item,index) in college_arr" >
					
					<div class="schli-r">
						<div class="schli-rt">
							<span class="schli-rt-a" @click="goInfo(item)">{{item.schoolName}}</span>
							<div class="schli-rB">
								<span class="schli-rB-span" v-if="item.citySchoolName">{{item.citySchoolName}} | </span>
								<span class="schli-rB-span" v-if="item.natureName">{{item.natureName}}</span>
							</div>
						</div>
						
						<div class="schli-rt">
							<span class="schli-rt-b" @click="goInfo(item)">{{item.majorName}}</span>
						</div>
						<div class="schli-rc">
							<div class="schli-rcA" v-if="item.branchs||item.rank">
								<span style="font-weight: 500;margin-right: 19px;">2026年</span>
								<span>预估分数/预估位次</span>
								
								<!-- <span v-if="user.batchId==8001">预估分数/预估位次</span>
								<span v-else>分数/位次</span> -->
								<span class="span1">{{item.branchs?item.branchs:'-'}}/{{item.rank?item.rank:'-'}}</span>
							</div>
							<div class="schli-rcA" v-if="item.probability">
								<span class="span1">{{item.probability?'[概率:'+item.probability+']':''}}</span>
							</div>
							<div class="schli-rcA">
								<span>院校代码</span>
								<span class="span1">{{item.schoolCode?item.schoolCode:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>专业代码</span>
								<span class="span1">{{item.majorCode?item.majorCode:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>招生数量</span>
								<span class="span1">{{item.plan?item.plan:'-'}}</span>
							</div>
							<div class="schli-rcA" v-if="item.yearEdu||item.money">
								<span>学制/年学费</span>
								<span class="span1">{{item.yearEdu?item.yearEdu:'-'}}/{{item.money?item.money:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>选科要求</span>
								<span class="span1">{{item.kemu?item.kemu:'-'}}</span>
							</div>
						</div>
						
						<div class="maindew" v-if="topNavid==2">
							
							<div class="maindewli">
								<span v-if="item.planOne||(item.branchOnes&&item.branchOnes!='-')||item.rankOne">2025年</span>
								
								<span v-if="item.branchOnes&&item.branchOnes!='-'||item.rankOne">最低分/位次 {{item.branchOnes?item.branchOnes:'-'}}/{{item.rankOne?item.rankOne:'-'}}</span>
								
								<div class="">
									<span v-if="item.planOne">录取{{item.planOne?item.planOne:'-'}}人</span>
								</div>
							</div>
							
							<div class="maindewli">
								<span v-if="item.planTwo||(item.branchTwos&&item.branchTwos!='-')||item.rankTwo">2024年</span>
								
								<span v-if="item.branchTwos&&item.branchTwos!='-'||item.rankTwo">最低分/位次 {{item.branchTwos?item.branchTwos:'-'}}/{{item.rankTwo?item.rankTwo:'-'}}</span>
								<div class="">
									<span v-if="item.planTwo">录取{{item.planTwo?item.planTwo:'-'}}人</span>
								</div>
							</div>
							
							<div class="maindewli">
								<span v-if="item.planThree||(item.branchThrees&&item.branchThrees!='-')||item.rankThree">2023年</span>
								
								<span v-if="item.branchThrees&&item.branchThrees!='-'||item.rankThree">最低分/位次 {{item.branchThrees?item.branchThrees:'-'}}/{{item.rankThree?item.rankThree:'-'}}</span>
								<div class="">
									<span v-if="item.planThree">录取{{item.planThree?item.planThree:'-'}}人</span>
								</div>
							</div>
							
						</div>
					</div>
					
					<div class="schli-b">
						<!-- <el-button v-if="college_arr.includes(item.id)" type="danger" size="medium"  @click="addMajor(item.id);">
							{{!college_arr.includes(item.id)?'填报':'志愿'+(college_arr.indexOf(item.id)+1)}}
						</el-button>
						
						<el-button v-else type="info" size="medium" plain  @click="addMajor(item.id);">
							{{!college_arr.includes(item.id)?'填报':'志愿'+(college_arr.indexOf(item.id)+1)}}
						</el-button> -->
						<div>
							<i style="font-size: 20px;color: #ABABAB;cursor: pointer;margin-right: 10px;" class="el-icon-delete" @click="deleteRow(item.id,item.schoolName,item.majorName)"></i>
							<i style="font-size: 20px;color: #ABABAB;cursor: pointer;" class="el-icon-rank" title="按住上下拖拽完成排序"></i>
						</div>
					</div>
					
				</div>
			</div>
			<el-empty v-if="!college_arr.length" :image-size="200"></el-empty>
		</div>
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
	
    
  </div>
</template>

<script>
	import { xuemengintro } from "@/api/intoxuemeng";
	import axios from 'axios';
	import  {UPLODE_URL} from '@/utils/request'
	import Sortable from 'sortablejs';
export default {
  data() {
    return {
		UPLODE_URL,
		sortable: {},
	  pageTotal:0,
	  busy: true,
	  topNavid:1,
	  radio2Data:[{name:'精简模式',id:1},{name:'详细模式',id:2}],
	  // 查询参数
	  queryParams: {
		status:1,//第一志愿表还是第二志愿表
		sort:2
	  },
	  college_arr:[],//选中的志愿id
	  cardType: localStorage.getItem('cardType')||'',//1主卡2子卡
	  token: localStorage.getItem('token')||'',
	  user:JSON.parse(localStorage.getItem('user'))||'',
	  isSticky: false,
	  stickyOffset: 0,
	  listid:[],//保存方案时候 存的id
	  indexFangan:{}//方案数据
    };
  },
 directives: {
     intersect: {
       bind(el, binding) {
         const observer = new IntersectionObserver((entries, observer) => {
 			  console.log('entries',entries)
           entries.forEach(entry => {
             if (entry.isIntersecting) {
               const img = entry.target;
 				console.log('2222sdfsfs',img)
               // 在这里可以做图片的懒加载处理，比如更改src属性
               // img.src = img.dataset.src;
               // 或者触发其他的方法
               // binding.value(entry, observer);
               // observer.unobserve(img); // 停止观察
 				// this.createObserver();
             }
           });
         });
  
         observer.observe(el);
       }
     }
   },
  created() {
	this.myVolList()
	// this.stickyOffset = document.querySelector('.sticky').offsetTop;
  },
  mounted() {
	  // // 阻止默认行为
	  //    document.body.ondrop = function(event) {
	  //      event.preventDefault()
	  //      event.stopPropagation()
	  //    }
	  window.addEventListener('scroll', this.handleScroll);
	  window.addEventListener('storage', this.handleStorageEvent);
  },
  beforeDestroy() {
  	  window.removeEventListener('scroll', this.handleScroll);
	  window.removeEventListener('storage', this.handleStorageEvent);
    },
  methods: {
	handleStorageEvent(event) {
	  if (event.key == 'token') {
		// 更新登录状态
			this.token=localStorage.getItem('token')||''
			this.user=JSON.parse(localStorage.getItem('user'))||''
			this.$router.push({path:'/'})
			window.location.reload()
		// this.checkLoginStatus();
	  }
	},
  // 跳转学校详情
	  goInfo(item){
		  // localStorage.setItem('xiaoid',item.schoolId)
		  // this.$router.push({path:'/Ainformation/schoolInfo'})
		  // return
		  
		  
		const route =this.$router.resolve({name:'schoolInfo',})
		localStorage.setItem('xiaoid',item.schoolId)
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  handleScroll() {
	        this.isSticky = window.scrollY >= this.stickyOffset;
			console.log('434343434',this.isSticky)
	    },
	  topClick(item){
		  this.topNavid = item.id
	  },
	  // 排序
	  handleCommand(command){
	    this.$confirm('确认操作？', '提示', {
	      confirmButtonText: '确认',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	      console.log('command',command)
	      this.queryParams.sort=command
	      this.myVolList()
	  
	    }).catch(() => {
	    // this.$message('click on item ' + command);
	    })
	  },
	  zhiClick(){
		  this.queryParams.sort=1
		  this.myVolList()
	  },
	  
	  //清空方案
	  saveDeleClick(){
	    this.$confirm(`清空后不可恢复，确定清空?`, '提示', {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消',
	      type: 'warning'
	    }).then(() => {
	       
	      let  quer= {
	       	jihuaIds:[],
	       	status:1,
	       	cardType:this.cardType,
	       	// cardType:2,
	       }
	       
	      
	      this.api.appMyAddJihuaApi(quer).then(res => {
	      		  if(res.code==200){
					  localStorage.setItem('myarrLengrh','null')
					  // localStorage.removeItem('myarrLengrh');
	      			  this.$message.success('操作成功');
	      			  this.myVolList()
	      		  }
	      })
	    }).catch(() => {
	  
	    });
	  },
	  
	  saveDeleNewClick(){
		  let  quer= {
		   	jihuaIds:[],
		   	status:1,
		   	cardType:this.cardType,
		   	// cardType:2,
		   }
		   
		  
		  this.api.appMyAddJihuaApi(quer).then(res => {
		  		  if(res.code==200){
		  					  localStorage.setItem('myarrLengrh','null')
		  					  // localStorage.removeItem('myarrLengrh');
		  			  this.$message.success('操作成功');
		  			  this.myVolList()
		  		  }
		  })
	  },
	  // 删除志愿
	  deleteRow(id,schname, name) {
	    this.$confirm(`确定删除 ${schname}-${name} ?`, '提示', {
	      confirmButtonText: '确定',
	      cancelButtonText: '取消',
		  confirmButtonClass:'qd',
		  cancelButtonClass:'qx',
	      type: 'warning'
	    }).then(() => {
	      this.college_arr.splice(this.college_arr.findIndex(item => item.id === id), 1)
	    }).catch(() => {
	     
	    });
	  },
	  //保存方案
	  saveClick(i) {
	   let that = this;
	   if (!that.college_arr.length ) {
	   	// uni.showToast({
	   	// 	title: '请预选志愿',
	   	// 	icon: 'none'
	   	// })
		this.saveDeleNewClick()
	   	return
	   }
	   //提前声明
	   let college_arrN = that.college_arr;
	   let arr = [];
	   for (let key in college_arrN) {
	   	arr.push(college_arrN[key].id);
	   }
	   console.log(arr)
	   arr = arr.join(",");
	   
	   
	   
	  let  quer= {
	   	jihuaIds:arr,
	   	status:0,
	   	cardType:that.cardType,
	   	// cardType:2,
	   }
	   
	  
	  this.api.appMyAddJihuaApi(quer).then(res => {
		  if(res.code==200){
			localStorage.setItem('myarrLengrh',quer.jihuaIds) 
			console.log('quer.jihuaIds',quer.jihuaIds)
			  this.$message.success('操作成功');
			  this.myVolList()
		  }
	  })
	  //   baokaoMyAddJihuaApi(params).then(res => {
	  //     if (res.code == 200) {
	  //      this.$modal.msgSuccess("操作成功");
	  //      this.getList()
	  //     }
	  
	  //   }).catch(function (error) {
	  //   });
	  },
	  /** 导出按钮操作 */
	  handleExport() {
	    if(!this.college_arr.length){
	      this.$message({
	        message: '无志愿可导出',
	        type: 'warning',
	        duration: '4000'
	      });
	      return
	    }
	  this.$confirm('确认导出？').then(function() {
	   }).then(() => {
	     let data = {
		   status: 1,
		   sort: this.queryParams.sort,
		   responseType: 'blob'
	     }
	     let URLS =`https://sy.xmedu.sd.cn/prod-api/app/open/export?status=1&sort=${this.queryParams.sort}`
		axios.post(URLS, {
		     responseType: 'blob',
		}, {
		    headers: {
		        'Authorization': this.token,
		        'token': this.token
		    },
			responseType: 'blob',
		})
		.then(response => {
			if(response.status==200&&response.data){
				const url = window.URL.createObjectURL(new Blob([response.data], { type: 'pplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
				// 创建标签a
				 let a= document.createElement('a')
				 // 设置隐藏
				 a.style.display = 'none'
				 // 给a标签地址
				 a.href = url
				 // 设置属性download和值，这是个特殊属性，参照图 3
				 a.setAttribute('download', `${this.user.mobile}_${new Date().getTime()}.xlsx`)
				 // 把a标签放入body，创建后的 a 标签，形如图 4
				 document.body.appendChild(a)
				 // 调用手动点击事件，相当于你做了一次点击
				a.click()
				// 释放该文件引用地址，当你结束使用某个 URL 对象之后，应该调用这个方法来让浏览器知道不用在内存中继续保留对这个文件的引用了(如果该页面有很多文件通过这种方法下载，这一步清理引用对性能优化尤为重要)
				window.URL.revokeObjectURL(url)
				// 移除a标签
				document.body.removeChild(a)
			}else{
				
			}
		           
		})
		.catch(error => {
		    console.error('There was an error!', error);
		});
		
		
	   }).catch(() => {});
	  },
	  
	  //获取我的志愿表
	  myVolList(){
		  let qu = {
		  	status:this.queryParams.status,
		  	sort:this.queryParams.sort,
		  }
		  this.api.getAppMyJihuaApi(qu).then(res => {
			  if(res.code==200){
				  if(res.data){
					  this.college_arr=[]
					  
					  this.college_arr = res.data
					  // res.data.map((item, index) => {
					  // 	console.log('item',item)
					  // 	console.log('index',index)
					  // 	// 计算scroll-view的宽度，这里
					  // 	this.college_arr.push(item.id) 
					  // })
					  console.log('2cccccc')
					  this.$nextTick(() => {
						  this.rowDrop()
					  })
				  }else{
					  this.college_arr=[]
				  }
			  }else{
				  this.$message.error(res.msg);
			  }
		  })
	  },
	  rowDrop() {
		  console.log('askljdbakldlkjabdklbajksbj')
	    const tbody = document.querySelector('.schmain .sch-ul');
		
	    this.sortable = Sortable.create(tbody, {
	      animation: 150,
	      ghostClass: 'blue-background-class',
	      chosenClass: "sortable-chosen",
	      onEnd: evt => {
	        let itemEl = evt.item; // dragged HTMLElement
	        let oldIndex = evt.oldIndex;
	        let newIndex = evt.newIndex;
	        let temp = this.college_arr[oldIndex];
	        if (oldIndex < newIndex) { //向下移动调整顺序
	          for (var i = oldIndex; i < newIndex; i++) {
	            this.college_arr[i] = this.college_arr[i + 1];
	          }
	        } else if (oldIndex > newIndex) { //向上移动时调整顺序
	          for (var i = oldIndex; i > newIndex; i--) {
	            this.college_arr[i] = this.college_arr[i - 1];
	          }
	        }
	  
	        console.log(oldIndex, newIndex)
	        this.college_arr[newIndex] = temp;
	        let newData = this.college_arr;
	        this.college_arr = [];
	        //重新更新数据  显示正确的索引
	        this.$nextTick(function() {
	          this.college_arr = newData;
	        });
	  
	      }
	    });
		console.log('this.sortable',this.sortable)
	  },
	   
	   
	   
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px 10px 20px;
		margin-top: 10px;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		-ms-flex-pack: justify;
		
		
		
		.topNav{
			display: flex;
			background: #F5F5F5;
			width: 240px;
			overflow: hidden;
			height: 40px;
			border-radius: 10px;
			align-items: center;
			justify-content: center;
			span{
				flex: 1;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #606060;
				font-size: 14px;
				cursor: pointer;
			}
			span:hover{
				color::#F44F4D ;
			}
			span:nth-child(1){
				border-right: 1px solid  #EEEEEE;
			}
			span.onsele{
				background:#F44F4D;
				color: #fff;
			}
		}
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				background-color: #F44F4D;
				color: #fff;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 40%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	.schmain{
		margin-top: 12px;
		// min-height: 80vh;	
		.box-tit{
			width: 100%;
			border-bottom: 1px solid #F44F4D;
			display: flex;
			background: #fff;
			padding-top: 10px;
			border-radius: 10px 10px 0 0;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				// background-color: #F44F4D;
				color: #333;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
				cursor: pointer;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				
			}
		}
		
		.sch-ul{
			background: #fff;
			border-radius: 10px;
			.sch-li{
				display: flex;
				// align-items: center;
				padding: 20px;
				// border-radius: 10px;
				display: flex;
				border-bottom: 1px solid #EEEEEE;
				.schli-l{
					width: 60px;
					margin-right: 20px;
					// img{
					// 	width: 60px;
					// 	height: 60px;
					// 	border-radius: 50%;
					// }
					
					
					.exaboxconli-l{
						text-align: center;
						position: relative;
					
						.btitle{
							font-size: 12px;
							color: #666666;
							white-space:nowrap
						}
						.bnum{
							position: absolute;
							top: 4px;
							left: 18px;
							font-size: 12px;
							color: #fff;
						}
						img{
							width: 46px;
							height: 53px;
						}
					}
					
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						font-size: 18px;
						cursor: pointer;
						display: flex;
						align-items: center;
						.schli-rt-a{
							margin-right: 30px;
						}
						.schli-rt-b{
							font-weight: bold;
							line-height: 44px;
						}
					}
					.schli-rB{
						display: flex;
						span{
							margin-right: 10px;
							font-size: 14px;
							color: #646464;
						}
					}
					
					.schli-rc{
						display: flex;
						.schli-rcA{
							display: flex;
							margin-right: 20px;
							span{
								color: #747474;
								font-size: 14px;
							}
							.span1{
								color: #000000;
								padding-left: 4px;
							}
						}
					}
					
					
					.maindew{
						margin-top: 10px;
						.maindewli{
							display: flex;
							span{
								margin-right: 20px;
								font-size: 13px;
							}
						}
					}
				}
				.schli-b{
					width: 150px;
					text-align: right;
					.el-button{
						width: 100px;
					}
				}
			}
		}
	}
}

.sticky {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}






// 悬浮框
#tzy-selected-pop {
    right: 0;
    position: fixed;
    top: 65px;
    width: 418px;
    height: 270px;
    z-index: 3000;
    -webkit-transition: all 1s;
    transition: all 1s;
    -webkit-transform: translateX(366px);
    transform: translateX(366px);
	display: flex;
}

#tzy-selected-pop.slide-out {
    -webkit-transform: translateX(0);
    transform: translateX(0)
}

#tzy-selected-pop .shoppingCarLeft {
    width: 52px;
    height: 270px;
    cursor: pointer
}
.pull-left {
    float: left
}


#tzy-selected-pop .foldBtn {
    display: inline-block;
    border: 1px solid transparent;
    border-right: none;
    border-top-left-radius: 4px;
    color: #fff;
    background: #F16334;
}
.f16 {
    font-size: 16px
}
.f18 {
    font-size: 18px
}
.yzy-button {
    border: 1px solid #F16334;
	color: #F16334;
}
.yzy-button.save {
    font-size: 14px;
    width: 52px;
    height: 60px;
	background-color: #fff;
}

.yzy-button.save:hover{
	color: red;
}

 .yzy-button.safe {
    border-bottom-left-radius: 4px;
}

#tzy-selected-pop .foldBtn>p {
    line-height: 22px;
    padding: 16px 16px;
    display: inline-block
}
#tzy-selected-pop .foldBtn>span {
    line-height: 25px;
    text-align: center;
    margin-bottom: 16px;
    display: inline-block;
    width: 100%
}
#tzy-selected-pop .shoppingCarRight {
    width: 366px;
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 0 0 0 4px;
    height: 100%;
    overflow: hidden
}

#tzy-selected-pop .searchInput {
    margin: 15px 20px 0;
    height: 40px;
    font-size: 12px;
    line-height: 18px;
    width: 326px
}

.ml30 {
    margin-left: 30px!important;
}
#tzy-selected-pop .chong.dataType{
    color: #fff;
    border-color: #e9302d;
    background-color: #e9302d;
}
.college-num {
    display: block;
    min-width: auto;
    min-height: 16px;
}
#tzy-selected-pop .professionItem {
    font-size: 14px;
    line-height: 22px;
    margin-top: 12px;
}
.professionName {
    width: 294px;
    display: inline-block;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
}
#tzy-selected-pop .cartCollegeName {
    display: inline-block;
    margin-left: 12px;
    width: 280px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    color: #212121;
}
#tzy-selected-pop .dataType{
    height: 18px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    padding: 0 4px;
}
.cartList{
    width: 100%;
    padding: 0 20px;
    overflow-y: auto;
	.cartListItem  {
	    padding: 20px 0;
	    border-bottom: 1px solid #e6e6e6;
		.cartCollege {
		    width: 100%;
		    line-height: 18px;
		    overflow: hidden;
		    height: 18px;
		    display: -webkit-box;
		    display: -ms-flexbox;
		    display: flex;
		}
	}
}



.toc0 .yzy-button.creat, .toc0 .yzy-button.creatsuccess {
    background-color: #F16334;
}.yzy-button.creatsuccess {
    margin-left: 20px;
    width: 336px;
    height: 44px;
    border: none;
    line-height: 44px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 4px;
	background-color: #F16334;
	color: #fff;
	font-size: 16px;
}
.el-cascader{
	width: 80%;
}

 // ghostClass: 'blue-background-class',
	//       chosenClass: "sortable-chosen",

.blue-background-class{
	// background: rgba(0.966 ,0.963 ,0.966, 1);
}
.sortable-chosen{
	// background: rgba(0.966 ,0.963 ,0.966, 0.2);
	background:#f0f0f0;
	// border-radius: 10px;
}

.el-dropdown{
	
}

</style>